import BaseService from './BaseService'

class ReportService extends BaseService {
  constructor() {
    super('/reports')
  }

  async getSalesReport(params = {}) {
    return this.customRequest('get', '/sales-summary', null, { params })
  }

  async getInventoryReport(params = {}) {
    return this.customRequest('get', '/inventory-detail', null, { params })
  }

  async getPaymentBreakdownReport(params = {}) {
    return this.customRequest('get', '/payment-breakdown', null, { params })
  }

  async getArAging(params = {}) {
    return this.customRequest('get', '/ar-aging', null, { params })
  }

  async getLoyaltySummary(params = {}) {
    return this.customRequest('get', '/loyalty-summary', null, { params })
  }

  async getSalesByCategory(params = {}) {
    return this.customRequest('get', '/sales-by-category', null, { params })
  }

  async getCustomerPurchaseDetail(params = {}) {
    return this.customRequest('get', '/customer-purchase-detail', null, { params })
  }

  // Export methods
  async exportSalesSummary(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/sales-summary/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  async exportPaymentBreakdown(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/payment-breakdown/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  async exportInventoryDetail(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/inventory-detail/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  async exportLoyaltySummary(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/loyalty-summary/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  async exportArAging(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/ar-aging/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  async exportSalesByCategory(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/sales-by-category/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  async exportCustomerPurchaseDetail(params = {}, format = 'excel') {
    const exportParams = { ...params, format }
    return this.customRequest('get', '/customer-purchase-detail/export', null, {
      params: exportParams,
      responseType: 'blob'
    })
  }

  // Placeholder for future custom reports
  async runCustomReport(queryConfig = {}) {
    return this.customRequest('post', '/custom', queryConfig)
  }
}

export const reportService = new ReportService()
